import { useGlobalConfig } from '../hooks';

type Path = string;
type LocalizedLink = string;

const localizeLink = (
    path: Path,
    lang?: string
): LocalizedLink => {
    let link: URL;

    try {
        link = new URL(path, window.location.href);
    }
    catch(e) {
        return String(path);
    }

    const { $isLocalizationEnabled, $lang } = useGlobalConfig();

    if ($isLocalizationEnabled) {
        link.pathname = '/' + (lang || $lang) + link.pathname;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('s');

    if (sessionId) {
        link.searchParams.append('s', sessionId);
    }

    return link.toString();
};

export { localizeLink }